export const CITY_DEFAULT = 'Київ';